//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectCityModal from './components/select-city-modal';
import { OrganizationMapToTreeDtos, OrganizationTreeDtoMapToTreeNodes } from '../../store/modules/organization';
import fileUploader from '../../views/common-components/file-uploader';

export default {
    name: 'projectList',
    components: { SelectCityModal, fileUploader },
    data() {
        const vm = this;
        return {
            searchInput: {},
            showProjectModel: false,
            loading: false,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '项目名称',
                    key: 'name',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.projectDetail(row);
                                }
                            }
                        }, row.name));
                        return h('div', actions);
                    }
                },
                {
                    title: '城市名称',
                    key: 'cityName',
                    align: 'center',
                    width: 100
                },
                {
                    title: '项目地址',
                    align: 'center',
                    key: 'address'
                },
                {
                    title: '是否关联组织节点',
                    key: 'organizationId',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', params.row.organizationId > 0 ? params.row.displayName : '否');
                    }
                },
                {
                    width: 220,
                    title: '操作',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];

                        var del = h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.delProject(params.row);
                                }
                            }
                        }, '删除');

                        if (vm.hasPermission('Pages.ProjectManage.Project.Edit')) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        vm.editProject(params.row);
                                    }
                                }
                            }, '编辑'));
                        }
                        var createOrganizationIdBtn = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.editProjectOrganizationId(params.row);
                                }
                            }
                        }, '绑定组织节点');

                        var delOrganizationIdBtn = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.delProjectOrganizationId(params.row);
                                }
                            }
                        }, '解绑组织节点');

                        if (vm.hasPermission('Pages.ProjectManage.Project.Organization')) {
                            if (params.row.organizationId > 0) {
                                actions.push(delOrganizationIdBtn);
                            } else {
                                actions.push(createOrganizationIdBtn);
                            }
                        }
                        if (vm.hasPermission('Pages.ProjectManage.Project.Delete')) {
                            actions.push(del);
                        }

                        return h('div', actions);
                    }
                }
            ],
            rules: {
                name: [
                    { required: true, message: '请输入项目名称', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请输入项目地址', trigger: 'blur' }
                ],
                cityName: [
                    { required: true, message: '不能为空', trigger: 'blur' }
                ],
                cityId: [{ required: true, type: 'number', message: '请选择城市', trigger: 'change' }]
            },
            project: {
                cityId: 0,
                file: {
                    associateType: 'CustomerServiceQRCode',
                    addAttrIds: [],
                    delAttrIds: []
                },
                id: 0
            },
            mTitle: '新增',
            saving: false,
            showAddCityModal: false,
            cityList: [],
            showTreeModal: false,
            createOrganization: {}
        };
    },
    computed: {
        currentPage() {
            return this.$store.state.project.currentPage;
        },
        totalCount() {
            return this.$store.state.project.totalCount;
        },
        pageSize() {
            return this.$store.state.project.pageSize;
        },
        list() {
            return this.$store.state.project.list;
        },
        nodes() {
            return this.$store.state.organization.companynodes;
        }

    },
    methods: {
        pageChange(page) {
            this.$store.commit('project/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.$store.commit('project/setPageSize', pagesize);
            this.getPage();
        },
        async getPage() {
            this.loading = true;
            await this.$store.dispatch({
                type: 'project/getAll',
                data: this.searchInput
            }).finally(() => {
                this.loading = false;
            });
        },
        save() {
            this.$refs.projectForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    this.$store.dispatch({
                        type: 'project/saveProject',
                        data: this.project
                    }).then(() => {
                        this.loading = false;
                        this.showProjectModel = false;
                        this.getPage();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        cancel() {
            // this.project = {};
            this.showProjectModel = false;
        },
        editProject(project) {
            if (project.id > 0) {
                this.mTitle = '编辑';
            } else {
                this.mTitle = '新增';
            }

            this.project = JSON.parse(JSON.stringify(project));
            this.project.file = {
                associateType: 'CustomerServiceQRCode',
                addAttrIds: [],
                delAttrIds: []
            };
            this.showProjectModel = true;
            this.saving = false;
        },
        delProject(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + row.name + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {

                    await this.$store.dispatch({
                        type: 'project/delProject',
                        id: row.id
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: '删除成功'
                        });
                        vm.getPage();
                    }).finally(() => {

                    });

                },
                onCancel: async () => {

                }
            });
        },
        showAddCity() {
            this.showAddCityModal = true;
        },
        addCity(city) {
            // console.log('111:' + city.name);
            this.project.cityName = city.name;
            this.project.cityId = city.id;
            this.showAddCityModal = false;
        },
        projectDetail(row) {
            this.$router.push({
                name: 'projectDetail',
                params: {
                    id: row.id
                }
            });
        },
        getCities() {
            this.$store.dispatch({
                type: 'city/getCityList'
            }).then(() => {
                this.cityList = [];
                this.cityList = this.$store.state.city.cityList;
            });
        },
        renderTree(h, { root, node, data }) {
            const vm = this;
            return h('span', [
                h('Icon', {
                    props: {
                        type: data.treeIcon,
                        color: data.color
                    },
                    style: {}
                }),
                h(
                    'Button', {
                        props: {
                            type: 'text'
                        },
                        on: {
                            click() {
                                // vm.selectedNode = data;
                                vm.selectedNode(data);
                            }
                        }
                    },
                    data.displayName
                )
            ]);
        },
        getAllOrganizations() {
            this.loading = true;

            this.$store.dispatch({
                type: 'organization/getCompanyNodes'
            }).finally(() => {
                this.loading = false;
            });

        },
        selectedNode(data) {
            const vm = this;
            // console.log(data);
            this.createOrganization.organizationId = data.id;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认绑定' + data.displayName + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {

                    abp.ajax.post('/api/services/app/Project/CreateOrganizationId', this.createOrganization).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: '绑定成功'
                        });
                        this.showTreeModal = false;
                        this.getPage();
                    }).finally(() => {

                    });
                    // await this.$store.dispatch({
                    //     type: 'project/delProject',
                    //     id: row.id
                    // }).then(() => {
                    //     this.$Notice.success({
                    //         duration: 3,
                    //         title: '删除成功'
                    //     });
                    //     vm.getPage();
                    // }).finally(() => {
                    //
                    // });

                }
            });
        },
        editProjectOrganizationId(row) {
            this.showTreeModal = true;
            this.createOrganization = {};
            this.createOrganization.id = row.id;
        },
        delProjectOrganizationId(row) {
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认解除绑定吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    abp.ajax.post('/api/services/app/Project/CancelOrganizationId', {
                        id: row.id,
                        organizationId: row.organizationId
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: '解除成功'
                        });
                        this.showTreeModal = false;
                        this.getPage();
                    }).finally(() => {

                    });
                },
                onCancel: async () => {

                }
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getPage();
        this.getCities();
        this.getAllOrganizations();
    }
};
